<template>
  <div
    class="bg-vlight-paper max-w-md sm:rounded-md mt-6 p-6 mx-auto shadow-lg"
  >
    <div class="text-center">
      <p
        class="mt-3 max-w-md mx-auto text-base  sm:text-xl md:mt-5 md:text-xl md:max-w-3xl"
      >
        Complete your Registration to Take Part
      </p>

      <router-link to="/updateDisplayName">
        <a class="bebas-btn bg-darkpurple hover:bg-peach mt-2">
          Complete
        </a>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddDisplayName"
};
</script>

<style scoped></style>
